import { RootState } from 'src/ui/app/store';

export const editIndexSelector = (state: RootState) =>
  state.connection.editIndex;

export const partnerConnectionSelectedOperation = (state: RootState) =>
  state.partnerconnection.operation;

export const selectedPartnerConnection = (state: RootState) =>
  state.partnerconnection.partnerConnectionDetail;

export const isBrowserAuthFailureSelector = (state: RootState) =>
  state.connection.isBrowserAuthFailure;

export const isDegradedSelector = (state: RootState) =>
  state.connection.isDegraded;

export const isUnauthorizedSelector = (state: RootState) =>
  state.connection.isUnauthorized;

export const ssoErrorCodeSelector = (state: RootState) =>
  state.connection.ssoErrorCode;
